export const supportEmail = "steriahouse@gmail.com";
export const supportTopics = ["Camera & filters", "Photo booth & collages", "PRO & purchases", "Watermark & rewarded ads", "Library & privacy", "Crash or other issue"] as const;

export type SupportReport = {
  topic: string;
  appVersion: string;
  device: string;
  iosVersion: string;
  message: string;
};

function clean(value: string, limit: number) {
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, "").trim().slice(0, limit);
}

export function createSupportMessage(report: SupportReport) {
  const topic = supportTopics.find((value) => value === report.topic) ?? "Crash or other issue";
  const body = [
    "Steriabooth support request",
    `Topic: ${topic}`,
    `App version: ${clean(report.appVersion, 40) || "Not provided"}`,
    `Device model: ${clean(report.device, 80) || "Not provided"}`,
    `iOS version: ${clean(report.iosVersion, 40) || "Not provided"}`,
    "", "What happened / steps to reproduce:", clean(report.message, 1200),
    "", "Please remove private photos, passwords, payment details, and unrelated personal information before sending.",
  ].join("\n");
  const subject = `Steriabooth Support — ${topic}`;
  return {
    subject,
    body,
    mailto: `mailto:${supportEmail}?${new URLSearchParams({ subject, body }).toString().replaceAll("+", "%20")}`,
    gmail: `https://mail.google.com/mail/?${new URLSearchParams({ view: "cm", fs: "1", to: supportEmail, su: subject, body })}`,
  };
}
